import type { TestIntent } from '@/types'

/**
 * Tailwind classes for a test's intent tint (happy-path / negative /
 * edge-case), shared so every surface that shows OR edits intent renders
 * the same accent color (#2126). Extracted from `CandidatesSection` when
 * the inline `IntentSelect` (candidate card + Tests screen) became a second
 * consumer of the same map — one map, no copy-paste. Mirrors the sibling
 * `priorityBadge.ts`.
 */
export const INTENT_BADGE: Record<TestIntent, string> = {
  'happy-path': 'bg-green-500/10 text-green-500 border-green-500/30',
  negative: 'bg-red-500/10 text-red-500 border-red-500/30',
  'edge-case': 'bg-amber-500/10 text-amber-500 border-amber-500/30',
}

/** Fallback tint for an absent or unrecognized intent — reads as neutral
 * rather than untinted so a blank control still looks deliberate. */
export const INTENT_NEUTRAL = 'bg-muted text-muted-foreground border-border'
